import { Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { formatNumber } from "../../../../../../infrastructure/utils/formatters";
import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { buildDrillDownHref, pick } from "../managementDashboardUtils";

const LoanPartnerPerformanceTable = ({ loading, error, data, onRetry }) => {
  const partners = data?.partners || data?.Partners || [];

  return (
    <ManagementWidgetShell
      title="عملکرد ارائه‌دهندگان وام"
      subheader="ارائه‌دهندگان به‌صورت پویا از SLN_LendingPartner"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      {!partners.length && !loading && !error ? (
        <Typography color="text.secondary">ارائه‌دهنده وام فعالی یافت نشد.</Typography>
      ) : (
        <TableContainer sx={{ overflowX: "auto" }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ارائه‌دهنده</TableCell>
                <TableCell align="right">متقاضی</TableCell>
                <TableCell align="right">تأیید</TableCell>
                <TableCell align="right">رد</TableCell>
                <TableCell align="right">پرداخت</TableCell>
                <TableCell align="right">نرخ تأیید</TableCell>
                <TableCell align="right">زمان پردازش</TableCell>
                <TableCell align="right">معطل</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {partners.map((row) => {
                const code = pick(row, "partnerCode", "PartnerCode");
                const href = buildDrillDownHref(pick(row, "drillDown", "DrillDown"));
                return (
                  <TableRow key={code} hover>
                    <TableCell>
                      {href ? (
                        <Link component={RouterLink} to={href} underline="hover">
                          {pick(row, "partnerTitle", "PartnerTitle")}
                        </Link>
                      ) : (
                        pick(row, "partnerTitle", "PartnerTitle")
                      )}
                    </TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "applications", "Applications"))}</TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "approved", "Approved"))}</TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "rejected", "Rejected"))}</TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "disbursed", "Disbursed"))}</TableCell>
                    <TableCell align="right">
                      {pick(row, "approvalRate", "ApprovalRate") != null
                        ? `${formatNumber(pick(row, "approvalRate", "ApprovalRate"), 1)}٪`
                        : "—"}
                    </TableCell>
                    <TableCell align="right">
                      {pick(row, "averageProcessingTimeDays", "AverageProcessingTimeDays") != null
                        ? `${formatNumber(pick(row, "averageProcessingTimeDays", "AverageProcessingTimeDays"), 1)} روز`
                        : "—"}
                    </TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "overdueCount", "OverdueCount"))}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </ManagementWidgetShell>
  );
};

export default LoanPartnerPerformanceTable;
